import { Component, Input } from '@angular/core';
import { EntityData } from 'common';

@Component({
    selector: 'ifb-entity-profile-company-info-widget',
    templateUrl: './entity-profile-company-info-widget.component.html',
    styleUrls: ['./entity-profile-company-info-widget.component.scss'],
    standalone: false
})
export class EntityProfileCompanyInfoWidgetComponent {
  @Input()
  data: EntityData;

  @Input()
  editable: boolean;
}
